<nav class="navbar navbar-light bg-light">
  <a class="navbar-brand d-grid ms-3" href="#">
    <img src="assets/img/logo.svg" [style.width.px]="90" alt="" loading="lazy">
    <p [style.font-size.px]="14" [style.margin-left.px]="45" [style.margin-top.px]="5">V {{ version }}</p>
  </a>

  <button
    class="navbar-toggler me-3"
    type="button"
    (click)="openOffcanvas(sidebar)"
    [ngClass]="{ 'd-none': !existUser, 'd-block': existUser }"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
</nav>

<ng-template #sidebar let-offcanvas>
  <div class="admin-nav-offcanvas">
      <div class="admin-nav-filter" role="radiogroup" aria-labelledby="admin-nav-filter-title">
        <p id="admin-nav-filter-title" class="admin-nav-filter__title">Mostrar</p>
        <div class="admin-nav-filter__list">
          <label
            *ngFor="let opt of filterOptions; trackBy: trackByFilterId"
            class="admin-nav-filter__choice"
            [class.admin-nav-filter__choice--active]="businessFilter === opt.id"
          >
            <input
              type="radio"
              name="adminBizFilter"
              class="admin-nav-filter__radio"
              [value]="opt.id"
              [checked]="businessFilter === opt.id"
              (change)="setBusinessFilter(opt.id)"
            />
            <span class="admin-nav-filter__text">{{ opt.label }}</span>
          </label>
        </div>
      </div>

    <div class="admin-nav-scroll">
      <ng-container *ngIf="showHormigonSection()">
        <section class="admin-nav-section" aria-label="Hormigón">
          <h2 class="admin-nav-section__title" *ngIf="showSectionHeadings()">Hormigón</h2>
          <ul class="admin-nav-list">
            <li class="admin-nav-list__item" *ngFor="let link of hormigonLinks; trackBy: trackByPath">
              <a
                class="admin-nav-link"
                [routerLink]="link.path"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="logMenuNavigation(link.path); closeOffcanvas()"
              >{{ link.label }}</a>
            </li>
          </ul>
        </section>
      </ng-container>

      <ng-container *ngIf="showCementoSection()">
        <section class="admin-nav-section" aria-label="Cemento">
          <h2 class="admin-nav-section__title" *ngIf="showSectionHeadings()">Cemento</h2>
          <ul class="admin-nav-list">
            <li class="admin-nav-list__item" *ngFor="let link of cementoLinks; trackBy: trackByPath">
              <a
                class="admin-nav-link"
                [routerLink]="link.path"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="logMenuNavigation(link.path); closeOffcanvas()"
              >{{ link.label }}</a>
            </li>
          </ul>
        </section>
      </ng-container>

      <section class="admin-nav-section admin-nav-section--footer" aria-label="Sesión">
        <ul class="admin-nav-list">
          <li class="admin-nav-list__item">
            <a
              class="admin-nav-link"
              [routerLink]="['/']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="logMenuNavigation('/'); closeSession()"
            >Cerrar sesión</a>
          </li>
        </ul>
      </section>
    </div>
  </div>
</ng-template>

<section class="pt-3">
  <router-outlet></router-outlet>
</section>
